import React from "react";

export function Section({ id, className = "", children, dark = false, pattern = false }) {
  return (
    <section id={id} className={`relative py-16 md:py-24 ${dark ? "bg-navy text-white" : ""} ${className}`}>
      {pattern && <div className="absolute inset-0 songket-pattern opacity-60 pointer-events-none" />}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">{children}</div>
    </section>
  );
}

export function Eyebrow({ children, className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 text-xs font-bold tracking-[0.18em] uppercase text-emerald-brand ${className}`}>
      <span className="w-6 h-px bg-gold" /> {children}
    </span>
  );
}

export function SectionHeading({ eyebrow, title, subtitle, center = false, light = false }) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} max-w-3xl mb-12`}>
      {eyebrow && <Eyebrow className={center ? "justify-center" : ""}>{eyebrow}</Eyebrow>}
      <h2 className={`mt-4 text-2xl md:text-3xl lg:text-4xl font-bold tracking-tight ${light ? "text-white" : "text-navy"}`}>{title}</h2>
      {subtitle && <p className={`mt-4 text-base leading-relaxed ${light ? "text-slate-300" : "text-slate-600"}`}>{subtitle}</p>}
    </div>
  );
}

export function WarningBox({ children, testid }) {
  return (
    <div data-testid={testid} className="rounded-xl border-l-4 bg-red-50 border-[#C8102E] p-5 md:p-6 flex gap-3">
      <span className="text-[#C8102E] text-xl font-bold shrink-0">!</span>
      <p className="text-sm md:text-[15px] text-red-900 leading-relaxed font-medium">{children}</p>
    </div>
  );
}

export function InfoBox({ children }) {
  return (
    <div className="rounded-xl border border-gold/40 bg-[#fdfaf0] p-5 md:p-6 flex gap-3">
      <span className="text-gold text-xl font-bold shrink-0">i</span>
      <p className="text-sm md:text-[15px] text-navy leading-relaxed">{children}</p>
    </div>
  );
}

export function ContactPill() {
  return <span className="text-emerald-brand font-semibold">Contact us to know more.</span>;
}
